export default "__VITE_ASSET__BstKgeXl__"